var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectedDashboardMainIcon(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard solid 1",
    clipPath: "url(#clip0_233_61092)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-3--Streamline-Core.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.35658 0.786133C1.48871 0.786133 0.785156 1.48968 0.785156 2.35756V11.7861C0.785156 12.654 1.48871 13.3576 2.35658 13.3576H8.6423C9.51018 13.3576 10.2137 12.654 10.2137 11.7861V2.35756C10.2137 1.48968 9.51018 0.786133 8.6423 0.786133H2.35658ZM11.7852 2.35756C11.7852 1.48968 12.4887 0.786133 13.3566 0.786133H19.6423C20.5102 0.786133 21.2137 1.48968 21.2137 2.35756V5.51613C21.2137 6.384 20.5102 7.08756 19.6423 7.08756H13.3566C12.4887 7.08756 11.7852 6.384 11.7852 5.51613V2.35756ZM11.7852 10.2147C11.7852 9.34684 12.4887 8.64328 13.3566 8.64328H19.6423C20.5102 8.64328 21.2137 9.34684 21.2137 10.2147V19.6433C21.2137 20.5112 20.5102 21.2147 19.6423 21.2147H13.3566C12.4887 21.2147 11.7852 20.5112 11.7852 19.6433V10.2147ZM0.785156 16.4847C0.785156 15.6168 1.48871 14.9133 2.35658 14.9133H8.6423C9.51018 14.9133 10.2137 15.6168 10.2137 16.4847V19.6433C10.2137 20.5112 9.51018 21.2147 8.6423 21.2147H2.35658C1.48871 21.2147 0.785156 20.5112 0.785156 19.6433V16.4847Z",
    fill: "#03045E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDashboardMainIcon);
export default __webpack_public_path__ + "static/media/SelectedDashboardMainIcon.c377f97a958b2a4c2fd1cdd47f0feb22.svg";
export { ForwardRef as ReactComponent };